export default __webpack_public_path__ + "static/media/Haruka Mirai.57f85fe3.mp3";